import { useToast } from 'primevue/usetoast';

export function useAppToast() {
    const toast = useToast();

    const showSuccess = (message: string, title: string = 'Успех') => {
        toast.add({
            severity: 'success',
            summary: title,
            detail: message,
            life: 4000,
        });
    };

    const showError = (message: string, title: string = 'Грешка') => {
        toast.add({
            severity: 'error',
            summary: title,
            detail: message,
            life: 5000,
        });
    };

    const showInfo = (message: string, title: string = 'Информация') => {
        toast.add({
            severity: 'info',
            summary: title,
            detail: message,
            life: 4000,
        });
    };

    const showWarn = (message: string, title: string = 'Внимание') => {
        toast.add({
            severity: 'warn',
            summary: title,
            detail: message,
            life: 4000,
        });
    };

    return { showSuccess, showError, showInfo, showWarn };
}

